export default __webpack_public_path__ + "static/media/S (28).6c6631ce.png";